import React from 'react'
import {
  MdCheckCircleOutline,
  MdClose,
  MdErrorOutline,
  MdInfoOutline,
  MdWarningAmber,
} from 'react-icons/md'

import enumToString from '@/libs/helpers/enum-to-string'

export type TToastType = 'success' | 'warning' | 'error'

export type TToast = {
  readonly id?: string
  readonly show: boolean
  readonly positionBottom?: boolean
  readonly type: TToastType
  readonly title: string
  readonly description?: string
  readonly traceId?: string
  readonly disableClose?: boolean
  readonly onClose?: () => void
  readonly actionElement?: any
}

export default function Toast({
  id,
  show,
  positionBottom,
  type = 'success',
  title,
  description,
  traceId,
  disableClose,
  onClose,
  actionElement,
}: TToast) {
  const typeClass = {
    success: 'border-pop-succees bg-pop-succees-background',
    warning: 'border-pop-alert bg-pop-alert-background',
    error: 'border-pop-error bg-pop-error-background',
  }[type]

  const iconType = {
    success: <MdCheckCircleOutline className='h-6 w-6 text-pop-green-600' />,
    warning: <MdWarningAmber className='h-6 w-6 text-pop-yellow-300' />,
    error: <MdErrorOutline className='h-6 w-6 text-pop-red-500' />,
    info: <MdInfoOutline className='h-6 w-6 text-pop-blue-600' />,
  }[type]

  return (
    <div
      id={`toast_${id}`}
      className={`${
        positionBottom
          ? 'fixed bottom-0 left-0 right-0 z-[999] mx-auto flex flex-col gap-4 px-5 py-4 md:w-1/2 md:py-6 lg:w-1/2 lg:py-9 xl:w-1/3 xl:py-12'
          : ''
      }`}
    >
      <div
        className={`${
          show ? 'flex flex-col md:flex-row' : 'hidden'
        } flex-row gap-3 rounded-2xl border ${typeClass} p-5 shadow-lg`}
      >
        <div className='flex flex-1 gap-3'>
          {iconType}
          <figure className='flex flex-col gap-1'>
            <figcaption className='font-semibold'>
              {title?.includes('_') ? enumToString(title || '') : title}
            </figcaption>
            {!!description && <p className='text-sm font-light'>{description}</p>}
            {!!traceId && (
              <p className='mt-2 text-xs font-light text-pop-grey-500'>Trace ID: {traceId}</p>
            )}
          </figure>
        </div>
        {disableClose ? null : (
          <MdClose
            className='my-auto ml-auto h-6 w-6 cursor-pointer text-pop-grey-600 lg:flex'
            onClick={onClose}
            data-testid='toast-close-button'
          />
        )}
        {actionElement && actionElement}
      </div>
    </div>
  )
}
